<section class="deletePopup">
  <div class="modal-dialog m-0">
    <div class="modal-content">
      <app-modal-header-common
        [title]="modalPopUpText?.confirmation_title"
        [dialogRef]="dialogRef"
      >
      </app-modal-header-common>

      <div class="modal-body" style="padding-bottom: 0px">
        <p
          [innerHTML]="
            deletionWarning ? deletionWarning : modalPopUpText?.cant_retrieve
          "
          style="text-align: center"
        ></p>
      </div>

      <div class="modal-footer">
        <div class="d-flex justify-content-end gap-2">
          <button mat-button (click)="closeDialog()">
            {{ buttonsText.cancel_btn }}
          </button>

          <button mat-flat-button color="primary" (click)="delete()">
            {{ buttonsText?.delete_btn }}
          </button>
        </div>
      </div>
    </div>
  </div>
</section>
